import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyle = makeStyles( theme => ({
    /* SECTION TITLE */
    stit : {
        fontFamily:"'Syne',sans-serif",
        fontSize: "20px",
        fontWeight:"700",
        marginBottom:"16px",
        display:"flex",
        alignItems:"center",
        gap:"10px",
        flexWrap:"wrap"
    },
   sub :
   {fontSize:"11px",fontWeight:"400",fontFamily:"'DM Sans',sans-serif"},
   
}));

const TitlePartner = ({ title, sub = "", icon = null }) => {
    const classes = useStyle(); 
    return (
          <div className={classes.stit}>
            {icon && icon} {title ?? ""} <span className={classes.sub} id="ctpt">{sub && sub}</span>
            </div>

    );
}

export default TitlePartner;